import PostHog from 'posthog-react-native';
import constants, { isPatientApp, isTherapistApp } from '@/config/constants';
import { Platform } from 'react-native';
import { FeatureFlag, featureFlagDefaults } from './featureFlags';
import { logError } from '@/utils/logHandling';

export const posthog = new PostHog(constants.posthogApiKey || '', {
  host: constants.posthogHost || 'https://eu.i.posthog.com',
  disableGeoip: true,
  defaultOptIn: constants.posthogEnabled,
  captureAppLifecycleEvents: true,
  enableSessionReplay: false,
  sendFeatureFlagEvent: false,
  disableRemoteFeatureFlags: isTherapistApp,
  preloadFeatureFlags: isPatientApp,
  customAppProperties: (defaults) => ({
    ...defaults,
    app_version: constants.appVersion,
    platform: Platform.OS,
    platform_version: Platform.Version,
    app_id: isPatientApp
      ? 'neolexon-aphasia-patient'
      : 'neolexon-aphasia-therapist',
  }),
});

posthog.on('error', (error) => logError('PostHog error:', error));

export const isFeatureEnabled = (flag: FeatureFlag): boolean =>
  posthog.isFeatureEnabled(flag) ?? featureFlagDefaults[flag];

export const identifyUser = (distinctId: string) =>
  posthog.identify(distinctId);

export const resetPostHog = () => {
  posthog.reset();
};
